import { AppDispatch, AppMiddleware } from "../..";
import { OperationAction, TypeKeys as OperationTypeKeys } from "../../operations";
import { rejoiningPayOnlyPartyOperation, rejoiningTableOperation } from "../../partyOnboarding/operations";
import { getRestaurantFlagsOperation } from "../../order/operations";
import { initializeFacebookPixel } from "../actions/initializeFacebookPixel";

let rejoining = false;

export const analyticsMiddleware =
    () =>
    (store: AppMiddleware) =>
    (next: AppDispatch) =>
    (action: OperationAction) => {
        next(action);

        if (action.type === OperationTypeKeys.BEGIN) {
            if (
                action.operation === rejoiningTableOperation.name ||
                action.operation === rejoiningPayOnlyPartyOperation.name
            ) {
                rejoining = true;
            }
        }

        if (
            action.type === OperationTypeKeys.COMPLETED ||
            action.type === OperationTypeKeys.FAILED ||
            action.type === OperationTypeKeys.RESET
        ) {
            if (
                action.operation === rejoiningTableOperation.name ||
                action.operation === rejoiningPayOnlyPartyOperation.name
            ) {
                rejoining = false;
            }
        }

        if (
            action.type === OperationTypeKeys.COMPLETED &&
            action.operation === getRestaurantFlagsOperation.name &&
            !rejoining
        ) {
            store.dispatch(initializeFacebookPixel());
        }
    };
